import { create } from 'zustand';

export type ToastType = 'success' | 'error' | 'info';

export interface Toast {
  id: string;
  type: ToastType;
  message: string;
}

interface ToastStore {
  toasts: Toast[];
  toast: (options: Omit<Toast, 'id'>) => void;
  dismiss: (id: string) => void;
}

let toastTimeout: ReturnType<typeof setTimeout> | null = null;

export const useToast = create<ToastStore>((set) => ({
  toasts: [],
  toast: (options) => {
    if (toastTimeout) {
      clearTimeout(toastTimeout);
    }
    const id = Math.random().toString(36).slice(2, 9);
    // Replace previous toast so only one message is displayed at a single spot
    set({ toasts: [{ ...options, id }] });
    toastTimeout = setTimeout(() => {
      set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
      toastTimeout = null;
    }, 4000);
  },
  dismiss: (id) => {
    if (toastTimeout) {
      clearTimeout(toastTimeout);
      toastTimeout = null;
    }
    set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
  },
}));
